module.exports = __webpack_public_path__ + "img/contactus.85023d78.png";